import { apiSlice } from "@app/api/apiSlice";

export const publicPageApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadPublicPageDetail: builder.query({
      query: (page_key) => `content/key/${page_key}`,
    }),
  }),
  overrideExisting: true,
});

export const { useLoadPublicPageDetailQuery } = publicPageApiSlice;
